import { set } from 'lodash/fp';

import moment from "moment";

const rowsOnPage = 30;

export const try_catch_fallback = function (method, fallback) {
    return function () {
        try {
            return method.apply(null, arguments);
        } catch (e) {
            return fallback;
        }
    };
};

export const JSONH = {
    decode: (object) => {
        const decode = eval(`(object) => ({ ${object.headers.map((header, index) => `["${header}"]: object[${index}]`)} })`);

        return object.data.map(decode);
    }
}

export const getPageSliceFromArray = (array, pageNum) => {
    const offset = ( pageNum - 1 ) * rowsOnPage;

    return array.slice(offset, offset + rowsOnPage);
};

export const roundTo2Decimal = float => roundTo(2, float);

export const roundTo3Decimal = float => roundTo(3, float);

export const roundTo = (digitsAfterPoint, float) => {
    const multiplier = Math.pow(10, digitsAfterPoint);

    return Math.floor(float * multiplier) / multiplier;
};

export const sumObject = obj => Object.keys(obj).reduce((total, country) => total + parseFloat(obj[country]), 0);

export const sum2Objects = (objA, objB) => {
    Object.keys(objB).forEach(param => {
        const value = parseFloat(objB[param]);

        if(objA[param]) objA[param] = parseFloat(objA[param]) + value;
        else objA[param] = value;
    });

    return objA;
};

export const to = promise => {
    return promise
        .then((data) => [null, data])
        .catch(err => [err]);
};

export const sortArray = (data, sortParam, sortOrder) => {
    data.sort((objA, objB) => {
        if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
        else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

        return 0;
    });
};

//don't change 'function', arrow function make issues with this
export function handleFieldChange({ target }) {
    let { name, value } = target;

    if (target.hasAttribute && target.hasAttribute('timestamp')) {
        if (name.includes('timestamp_gt')) value = moment.utc(value).startOf('day').unix();
        if (name.includes('timestamp_lt')) value = moment.utc(value).endOf('day').unix();
    }

    this.setState(set(name.split('.'), value, this.state));
}

export function handleGroupByChange({ target }) {
    const { name, checked } = target;

    const state = this.state;

    if (checked) {
        state.group_by.push(name);
    } else {
        state.group_by = state.group_by.filter(x => x !== name);
    }

    this.setState(state);
}

export function handleCheckboxChange({ target }) {
    const { name, checked } = target;

    this.setState({ [name]: checked ? 1 : '' });
}

export function getDeviceName(device) {
    if(device === 'd') return 'Desktop';
    if(device === 'm') return 'Mobile';

    return '';
}

export const capitalize = string => string[0].toUpperCase() + string.slice(1);

const Utils = { getPageSliceFromArray, roundTo2Decimal, roundTo3Decimal, roundTo, sumObject, sum2Objects, to, sortArray, handleFieldChange, handleCheckboxChange, getDeviceName };

export default Utils;



// WEBPACK FOOTER //
// ./src/Utils.js